<div class="row">
  <div class="col-3">
    <div class="list-group list-group-flush"
         #subjectContainer>
      <a *ngFor="let subject of domain?.subjects;let i = index"
         (click)="selectedSubjects.indexOf(subject) > -1 ? deselectSubject(subject) : selectSubject(subject)"
         [class.selected]="selectedSubjects.indexOf(subject) > -1"
         [attr.id]="'subjectcode'+subject.code"
         class="list-group-item list-group-item-action text-uppercase font-weight-bold px-0 py-2 text-muted small"
         [style.background-color]="selectedSubjects.indexOf(subject) > -1 ? colorLightScale(domain.id, subject.code) : 'transparent'">
        {{ subject.title }}
      </a>
    </div>
  </div>
  <div class="col pl-3">
    <div class="row"
         [id]="'section' + domain?.subjects.indexOf(subject)"
         *ngFor="let subject of selectedSubjects;let i = index">
      <div class="col">
        <!-- <h6 [attr.id]="'subjecttitle'+subject.code">{{ subject.title }}</h6> -->
        <div class="row my-3 align-items-center"
             *ngFor="let goal of subject.goals; trackBy: idGoal">
          <div class="col-4 pr-4">
            <a (click)="selectedGoal === goal ? deselectGoal(goal) : selectGoal(goal)"
               [attr.id]="goal.code"
               [style.borderWidth.px]="selectedGoal === goal ? 2 : 1"
               [style.opacity]="!selectedGoal || selectedGoal === goal ? 1 : 0.7"
               class="list-group-item list-group-item-action font-weight-bold"
               style="border-radius:2rem"
               [style.background-color]="selectedSubjects.indexOf(subject) > -1 ? colorLightScale(domain.id, subject.code) : 'transparent'"
               [style.border-color]="selectedSubjects.indexOf(subject) > -1 ? colorScale(domain.id, subject.code) : 'transparent'">
              <div class="in"
                   *ngIf="selectedGoal != goal">
                <div *ngFor="let in of goal.in;"
                     [style.background-color]="colorScale(domain.id, subject.code)"></div>
              </div>
              <div class="out"
                   *ngIf="selectedGoal != goal">
                <div *ngFor="let out of goal.out;"
                     [style.background-color]="colorScale(domain.id, subject.code)"></div>
              </div>
              {{ goal.title }}
            </a>
          </div>
          <div class="col-8">
            <ng-container *ngFor="let learningObjective of goal.learningObjectives; trackBy: idLearningObjective">
              <div>
                <div *ngFor="let subLearningObjective of learningObjective?.learningObjectives; trackBy: idLearningObjective"
                     [class.active]="selectedLearningObjective && subLearningObjective.id === selectedLearningObjective.id"
                     [attr.id]="'categories-' + subLearningObjective.id"
                     [style.margin-left]="'20px'"
                     class="list-group-item p-0 d-flex">
                  <div class="align-self-center text-muted flex-shrink-1 p-1 border-0">
                    <input type="checkbox"
                           class="checklo"
                           [disabled]="!editMode"
                           [ngModel]="subLearningObjective.inList"
                           (change)="toggleLearningObjectiveHandler(subLearningObjective)" />
                  </div>
                  <app-learning-objective-view class="flex-grow-1 p-1"
                                               [class.c-pointer]="subLearningObjective.inList"
                                               [class.clickable]="subLearningObjective.inList"
                                               (click)="select(subLearningObjective)"
                                               [class.text-muted]="!subLearningObjective.inList"
                                               [learningObjective]="subLearningObjective">
                  </app-learning-objective-view>
                </div>
              </div>
              <div class="">
                <div [attr.id]="'categories-' + learningObjective.id"
                     [class.active]="selectedLearningObjective && learningObjective.id === selectedLearningObjective.id"
                     class="list-group-item p-0 d-flex border-0 m-1">
                  <div class="p-3 d-flex align-items-center">
                      <div class="toggle-button toggle-button--tuuli">                          
                          <input type="checkbox"
                           [id]="learningObjective.id"
                           [disabled]="!editMode"
                           [ngModel]="learningObjective.inList"
                           (change)="toggleLearningObjectiveHandler(learningObjective)" />

                          <label [for]="learningObjective.id" class="m-0"></label>
                          <div class="toggle-button__icon"></div>
                      </div>
                    
                  </div>
                  <app-learning-objective-view class="flex-grow-1 p-1"
                                               [class.c-pointer]="learningObjective.inList"
                                               [class.clickable]="learningObjective.inList"
                                               (click)="select(learningObjective)"
                                               [class.text-muted]="!learningObjective.inList"
                                               [learningObjective]="learningObjective">
                  </app-learning-objective-view>
                </div>
              </div>
            </ng-container>



          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- [class.text-muted]="learningObjective.inList"
[class.font-italic]="learningObjective.inList" -->